import {createContext, useContext, useMemo, type PropsWithChildren} from 'react'
import {noop} from '@github-ui/noop'

export type SelectionContextProps = {
  isSelected: boolean
  onSelect: (isSelected: boolean) => void
}

const SelectionContext = createContext<SelectionContextProps>({isSelected: false, onSelect: noop})

type SelectionProviderProps = PropsWithChildren & {value: SelectionContextProps}

export const SelectionProvider = ({children, value: {isSelected, onSelect}}: SelectionProviderProps) => {
  const contextProps = useMemo(() => ({isSelected, onSelect}), [isSelected, onSelect])
  return <SelectionContext.Provider value={contextProps}>{children}</SelectionContext.Provider>
}

export const useListItemSelection = () => {
  return useContext(SelectionContext)
}

try{ SelectionContext.displayName ||= 'SelectionContext' } catch {}
try{ SelectionProvider.displayName ||= 'SelectionProvider' } catch {}